import { render, staticRenderFns } from "./EditCategoryModal.vue?vue&type=template&id=784c290d&"
import script from "./EditCategoryModal.vue?vue&type=script&lang=js&"
export * from "./EditCategoryModal.vue?vue&type=script&lang=js&"
import style0 from "./EditCategoryModal.vue?vue&type=style&index=0&id=784c290d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports